import MediaCard from "./MediaCard";

export default MediaCard;